import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { colors } from '@src/styles';
import { ActionDTO } from '@src/services/tools/modules/v1/scripts/dto/tools-requests.dto';
import { MethodChip } from '../MethodChip';
import { StatusChip } from '../StatusChip';
import { monoFontFamily, monoLabelSX, titleFontFamily } from '../../scriptsStyles';

interface ModalHeaderProps {
  title: string;
  onClose: () => void;
  actionData?: ActionDTO | null;
}

export const ModalHeader = ({ title, onClose, actionData }: ModalHeaderProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 2,
        px: 3,
        pt: 2.5,
        pb: 2,
        flexShrink: 0,
        borderBottom: `1px solid ${colors.brand.line}`,
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography id="response-details-modal" sx={monoLabelSX}>
            {title}
          </Typography>
          {actionData && (
            <Typography sx={{ ...monoLabelSX, color: colors.brand.textSecondary }}>
              · layer {actionData.layer}
            </Typography>
          )}
        </Box>
        {actionData ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mt: 1, flexWrap: 'wrap' }}>
            <MethodChip method={actionData.method} />
            <Typography
              title={actionData.url}
              sx={{
                flex: '1 1 300px',
                minWidth: 0,
                fontFamily: monoFontFamily,
                fontSize: '13.5px',
                color: colors.primary.white,
                wordBreak: 'break-all',
              }}
            >
              {actionData.url || 'N/A'}
            </Typography>
            <StatusChip status={actionData.status} />
          </Box>
        ) : (
          <Typography sx={{ fontFamily: titleFontFamily, fontSize: '18px', fontWeight: 500, mt: 0.5 }}>
            {title}
          </Typography>
        )}
      </Box>
      <Tooltip title="Fechar" arrow>
        <IconButton
          onClick={onClose}
          aria-label="Fechar"
          sx={{
            width: 32,
            height: 32,
            flexShrink: 0,
            color: colors.brand.textSecondary,
            '& svg': { color: 'inherit' },
            '&:hover': { color: colors.primary.white, backgroundColor: 'rgba(255, 160, 21, 0.1)' },
          }}
        >
          <CloseRoundedIcon sx={{ fontSize: 19 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
